import { Box, Button, Grid, TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import SelectLocaisCobranca from "../../../../../../../components/SelectsSimpleApiQuery/SelectLocaisCobranca";
import SelectPlanoContas from "../../../../../../../components/SelectsSimpleApiQuery/SelectPlanoContas";
import SelectHistoricoFinanceiro from "../../../../../../../components/SelectsSimpleApiQuery/SelectHistoricoFinanceiro";
import SelectDepartamentoFinanceiro from "../../../../../../../components/SelectsSimpleApiQuery/SelectDepartamentoFinanceiro";
import SelectContaCorrente from "../../../../../../../components/SelectsSimpleApiQuery/SelectContaCorrente";
import SelectNaturezaRendimento from "../../../../../../../components/SelectsSimpleApiQuery/SelectNaturezaRendimento";

export default function Step03() {
  const { getValues, handleSubmit, control, setValue } = useFormContext();
  const handleBack = getValues("funcoesAux.onBack");
  const handleNext = getValues("funcoesAux.onNext");
  const codigoPublico = getValues("step01.publico_dado.codigo_publico");
  const tipoPublico = getValues("step01.publico_dado.tipo_publico");

  const titulo = {
    publico: {
      tipo_publico: tipoPublico,
      codigo_publico: codigoPublico,
      nome_pessoa: "",
    },
  };

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 12 }}>
        <Controller
          name="step03.conta_bancaria"
          control={control}
          render={({ field, fieldState: { error, invalid } }) => {
            return (
              <SelectContaCorrente
                value={field.value ?? null}
                onChange={(valor) => {
                  field.onChange(valor);
                }}
                titulo={titulo}
              />
            )
          }}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Controller
          name="step03.local_cobranca"
          control={control}
          rules={{ required: "Campo obrigatório" }}
          render={({ field, fieldState: { error, invalid } }) => (
            <SelectLocaisCobranca
              {...field}
              required
              error={invalid}
              value={field.value}
              onChange={(valor) => {
                field.onChange(valor);
              }}
            />
          )}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Controller
          name="step03.departamento"
          control={control}
          rules={{ required: "Campo obrigatório" }}
          render={({ field, fieldState: { error, invalid } }) => (
            <SelectDepartamentoFinanceiro
              {...field}
              required
              error={invalid}
              value={field.value}
              onChange={(valor) => field.onChange(valor)}
            />
          )}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Controller
          name="step03.historico"
          control={control}
          rules={{ required: "Campo obrigatório" }}
          render={({ field, fieldState: { error, invalid } }) => (
            <SelectHistoricoFinanceiro
              {...field}
              required
              error={invalid}
              value={field.value}
              onChange={(valor) => {
                setValue("step03.historico", valor);
                setValue("step03.historico.nome", valor?.nome);
                setValue("step03.historico.descricao", valor?.nome);
              }}
            />
          )}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Controller
          name="step03.historico.descricao"
          control={control}
          rules={{ required: "Campo obrigatório" }}
          render={({ field, fieldState: { error } }) => (
            <TextField
              label="Descrição histórico"
              value={field.value || ""}
              fullWidth
              required
              error={Boolean(error)}
              helperText={error ? "Campo obrigatório" : ""}
              onChange={(e) => {
                setValue(`step03.historico.descricao`, e.target.value);
              }}
              slotProps={{ htmlInput: { maxLength: 60 } }}
            />
          )}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Controller
          name="step03.conta_devedora"
          control={control}
          rules={{ required: "Campo obrigatório" }}
          render={({ field, fieldState: { error, invalid } }) => (
            <SelectPlanoContas
              inputLabel="Conta devedora"
              value={field.value}
              required
              error={invalid}
              onChangeValue={(valor) => field.onChange(valor)}
              extraParams={{ tipo: "Analítica" }}
            />
          )}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Controller
          name="step03.conta_credora"
          control={control}
          rules={{ required: "Campo obrigatório" }}
          render={({ field, fieldState: { error, invalid } }) => (
            <SelectPlanoContas
              inputLabel="Conta credora"
              required
              error={invalid}
              value={field.value}
              onChangeValue={(valor) => field.onChange(valor)}
              extraParams={{ sistema_xy: "D-PAG", tipo: "Analítica" }}
            />
          )}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Controller
          name={"step03.natureza_rendimento"}
          control={control}
          render={({ field, fieldState: { error, invalid } }) => (
            <SelectNaturezaRendimento
              value={field.value}
              onChange={(valor) => {
                field.onChange(valor);
                setValue("step03.natureza_rendimento", valor);
              }}
            />
          )}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Controller
          name="step03.observacao"
          control={control}
          render={({ field }) => (
            <TextField
              label="Observação"
              fullWidth
              value={field.value}
              multiline
              minRows={2}
              onChange={(e) => {
                field.onChange(e.target.value.trimStart());
              }}
              slotProps={{ htmlInput: { maxLength: 80 } }}
            />
          )}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Box display={"flex"} gap={2}>
          <Button variant="outlined" onClick={handleBack}>
            Voltar
          </Button>
          <Button variant="contained" onClick={handleSubmit(handleNext)}>
            Avançar
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
}
